import React from 'react'
import { Image } from '@mantine/core'
import WinnerAnnouncements from './components/WinnerAnnouncements'
import ScratchCardHeader from './components/ScratchCardHeader'
import ScratchArea from './components/ScratchArea'
import PrizePreview from './components/PrizePreview'

interface ScratchCardProps {}

const ScratchCard: React.FC<ScratchCardProps> = () => {
  return (
    <div
      style={{
        background: 'linear-gradient( 90deg, #FFE2B3 7%, #FDE6E9 59%, #FFF6DB 100%)',
        padding: 12,
        borderRadius: 24,
        position: 'relative',
        overflow: 'visible',
        marginTop: -20,
      }}
    >
      <Image
        src="/moto.png"
        style={{
          position: 'absolute',
          top: -120,
          right: -30,
          width: 180,
          height: 'auto',
          zIndex: 1,
        }}
      />
      <ScratchCardHeader />
      <div style={{ marginBottom: 12, marginTop: 8 }}>
        <WinnerAnnouncements />
      </div>
      <ScratchArea />
      <PrizePreview />
    </div>
  )
}

export default ScratchCard
